import axios from 'axios';

// Central axios instance
// - baseURL via env (works for dev/hml/prod)
// - timeout to avoid hanging requests
// - response interceptor to keep a single place for error shaping

const baseURL = (process.env.REACT_APP_API_URL || '').trim() || 'http://api-termo.passefacil.com.br';

export const api = axios.create({
  baseURL,
  timeout: 20000,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Keep the raw error for consumers that need it, but normalize common cases.
    // (Toast handling should be done in UI layer to avoid duplicate notifications.)
    return Promise.reject(error);
  }
);

export default api;
